var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.items, function (item) {
      return _c("filter-label", {
        key: item.key,
        attrs: { item: item },
        on: { clear: _vm.onClear },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }